import { Link } from 'react-router-dom';

export const NotFoundPage = () => (
  <main className="not-found">
    <span>404</span>
    <h1>Page not found</h1>
    <p>The page you requested does not exist in this workspace.</p>
    <Link to="/" className="button button-primary">Return to overview</Link>
  </main>
);
